<template>
  <section>
    <top-menu/>

    <section>
      <page-header :headerName="'Avisos e Campanhas'" :showBtn="true" :btnName="'Novo aviso'"
                   :btnRoute="'/avisos-e-campanhas/novo'" :css="'container'"/>

      <div class="page-content">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box filters">

                <feature-window-tabs :current="'broadcasts'"/>

                <!--
                  Enquanto algum banco nao responder, Entregues, Cliques e Dispensas
                  estao incompletos: podem faltar ate um oitavo da plataforma.
                -->
                <div class="bl-warn" v-if="shardsFailed.length">
                  Numeros incompletos: {{ shardsFailed.join(', ') }} nao responderam.
                </div>

                <filter-bar v-if="!loadFailed && items.length" :active="filtersActive" @clear="clearFilters">
                  <date-range-filter label="Criado em" :from.sync="filters.criadoDe" :to.sync="filters.criadoAte"/>
                  <date-range-filter label="Período ativo" :from.sync="filters.ativoDe" :to.sync="filters.ativoAte"/>
                  <filter-select label="Tipo" v-model="filters.tipo" :options="typeOptions"/>
                  <filter-select label="Situação" v-model="filters.situacao" :options="statusOptions"/>
                  <filter-select label="Responsável" v-model="filters.responsavel" :options="ownerOptions"/>
                </filter-bar>

                <paged-table class="bl-table" v-if="!loadFailed && visibleItems.length"
                             :rows="visibleItems" storage-key="broadcast-list" v-slot="{ rows }">
                  <thead>
                  <tr>
                    <th>Título</th>
                    <th style="width:150px">Tipo</th>
                    <th style="width:190px">Período</th>
                    <th style="width:110px">Empresas</th>
                    <th style="width:100px">Entregues</th>
                    <th style="width:90px">Cliques</th>
                    <th style="width:100px">Dispensas</th>
                    <th style="width:150px">Situação</th>
                    <th style="width:110px">Ações</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!--
                    A linha inteira nao e mais um botao invisivel: nada nela dizia
                    que havia algo para clicar. O engajamento agora e um link
                    nomeado, que abre em pagina propria e pode ser copiado,
                    favoritado e aberto em outra aba.
                  -->
                  <tr v-for="item in rows" :key="item.id">
                    <td>{{ item.title }}</td>
                    <td>{{ typeLabel(item.type) }}</td>
                    <td>{{ period(item) }}</td>
                    <td>{{ item.targeted }}</td>
                    <td>{{ item.delivered }}</td>
                    <td>{{ clicksLabel(item) }}</td>
                    <td>{{ item.dismissed }}</td>
                    <td>
                      <span class="bl-chip" :class="statusClass(item)">{{ statusLabel(item) }}</span>
                    </td>
                    <td class="bl-actions">
                      <router-link class="bl-actions__link" :to="engagementRoute(item)"
                                   v-tooltip.top-center="'Ver engajamento'">
                        <i class="fa fa-bar-chart" aria-hidden="true"></i>
                      </router-link>
                      <i class="fa fa-pencil" aria-hidden="true"
                         v-if="isEditable(item)"
                         v-tooltip.top-center="'Editar aviso'"
                         v-on:click.stop="edit(item)"></i>
                      <i class="fa fa-trash bl-actions__danger" aria-hidden="true"
                         v-if="!item.cancelledAt"
                         v-tooltip.top-center="'Cancelar aviso'"
                         v-on:click.stop="confirmCancel(item)"></i>
                    </td>
                  </tr>
                  </tbody>
                </paged-table>

                <p class="bl-no-match" v-else-if="!loadFailed && items.length">
                  Nenhum resultado para os filtros selecionados.
                  <a href="#" @click.prevent="clearFilters">Limpar filtros</a>
                </p>

                <!--
                  Falha de rede tambem e uma alegacao quando some atras de "nenhum
                  aviso": as duas telas tem a mesma ausencia de linhas, mas
                  significam coisas opostas. loadFailed separa "nao sabemos" de
                  "sabemos, e e zero" -- mesma distincao de broadcastEngagementPage.vue.
                -->
                <p class="bl-warn" v-else-if="loadFailed">
                  Não foi possível carregar os avisos e campanhas.
                </p>

                <!-- emptyState nao aceita props: o texto dele e fixo. -->
                <empty-state v-else-if="!loading"/>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <full-loading v-if="loading" transparent/>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pagedTable from "../../components/default/pagedTable.vue";
import filterBar from "../../components/default/filterBar.vue";
import filterSelect from "../../components/default/filterSelect.vue";
import dateRangeFilter from "../../components/default/dateRangeFilter.vue";
import { listFilterState } from "../../components/default/listFilterState";
import {
  createdWithin, matchesOwner, overlapsPeriod, ownerOptions,
} from "../../components/default/listFilters";
import emptyState from "../../components/layouts/emptyState.vue";
import swal from 'sweetalert';
import featureWindowTabs from "../featureWindow/featureWindowTabs.vue";
import { isNoCrossToken, requestApiV2 } from "./broadcastApiV2Auth";
import { BROADCASTS, BROADCAST_CANCEL } from "../../../../urlConfig";
import { BROADCAST_TYPE, BROADCAST_TYPE_OPTIONS_ALL } from "./broadcastEnums";
import { BROADCAST_STATUS_LABELS as STATUS_LABELS, broadcastStatusKey, lockedReason } from "./broadcastStatus";

export default {
  name: "broadcast-list",
  components: {
    topMenu, pageHeader, fullLoading, emptyState, featureWindowTabs, pagedTable,
    filterBar, filterSelect, dateRangeFilter,
  },
  mixins: [listFilterState('broadcast-list', {
    criadoDe: '', criadoAte: '', ativoDe: '', ativoAte: '', tipo: '', situacao: '', responsavel: '',
  })],
  data() {
    return {
      loading: false,
      loadFailed: false,
      items: [],
      shardsFailed: [],
    };
  },
  created() {
    this.load();
  },
  computed: {
    typeOptions() {
      return BROADCAST_TYPE_OPTIONS_ALL.map((o) => ({ value: o.value, label: o.label }));
    },
    statusOptions() {
      return Object.keys(STATUS_LABELS).map((key) => ({ value: key, label: STATUS_LABELS[key] }));
    },
    ownerOptions() {
      return ownerOptions(this.items);
    },
    /** Filtra antes de paginar: o "1–10 de N" do rodape ja conta so o que passou. */
    visibleItems() {
      const f = this.filters;
      return this.items.filter((item) =>
        createdWithin(item.createdAt, f.criadoDe, f.criadoAte) &&
        overlapsPeriod(item.startsAt, item.endsAt, f.ativoDe, f.ativoAte) &&
        (!f.tipo || String(item.type) === f.tipo) &&
        (!f.situacao || this.statusKey(item) === f.situacao) &&
        matchesOwner(item.createdByName, f.responsavel));
    },
  },
  methods: {
    load() {
      this.loading = true;
      this.loadFailed = false;
      requestApiV2('GET', BROADCASTS)
        .then((response) => {
          const data = (response && response.data) || {};
          this.items = data.items || [];
          this.shardsFailed = data.shardsFailed || [];
          this.loadFailed = false;
        })
        .catch((error) => {
          // Sem cross token nenhuma requisicao sai: avisa para refazer o login
          // em vez de falhar calado.
          if (isNoCrossToken(error)) {
            swal("Aviso", "Saia e entre novamente no Master para autenticar na API v2.", "error");
          }
          // Falhar a leitura nao pode virar "zero campanhas": a tela generica de
          // vazio e o load com erro contam historias opostas. loadFailed separa
          // as duas, do mesmo jeito que broadcastEngagementPage.vue separa.
          this.items = [];
          this.shardsFailed = [];
          this.loadFailed = true;
        })
        .then(() => {
          this.loading = false;
        });
    },
    edit(item) {
      this.$router.push('/avisos-e-campanhas/' + item.id + '/editar');
    },
    confirmCancel(item) {
      swal({
        title: "Aviso",
        text:
          'Cancelar o aviso "' + item.title + '"?\n' +
          'Ele deixa de aparecer para os usuários. O histórico é preservado.',
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((confirmed) => {
        if (confirmed) this.cancel(item);
      });
    },
    /**
     * Cancelamento e SUAVE: a campanha para de aparecer mas a linha, as
     * entregas e os cliques continuam no banco. Por isso o botao chama
     * `cancel` e nao `DELETE`, que apagaria o historico de todos os bancos.
     */
    cancel(item) {
      this.loading = true;

      requestApiV2('POST', BROADCAST_CANCEL(item.id))
        .then(() => {
          swal("Aviso", "Aviso cancelado.", "success");
          this.load();
        })
        .catch((error) => {
          this.loading = false;
          swal(
            "Aviso",
            isNoCrossToken(error)
              ? "Saia e entre novamente no Master para autenticar na API v2."
              : "Não foi possível cancelar o aviso.",
            "error"
          );
        });
    },
    engagementRoute(item) {
      return '/avisos-e-campanhas/' + item.id + '/engajamento';
    },
    typeLabel(type) {
      const found = BROADCAST_TYPE_OPTIONS_ALL.find((o) => o.value === type);
      return found ? found.label : 'Desconhecido';
    },
    /**
     * Release note nao redireciona: o botao da modal dispensa em vez de navegar.
     * Mostrar 0 faria toda release note parecer fracasso, quando na verdade nao
     * existe clique a medir.
     */
    clicksLabel(item) {
      if (item.type === BROADCAST_TYPE.RELEASE_NOTE) return 'n/a';
      return item.clickers + ' (' + item.clicks + ')';
    },
    period(item) {
      const start = this.date(item.startsAt);
      return item.endsAt ? start + ' até ' + this.date(item.endsAt) : start + ' — sem fim';
    },
    date(value) {
      if (!value) return '';
      const parsed = new Date(value);
      return isNaN(parsed.getTime()) ? '' : parsed.toLocaleDateString('pt-BR');
    },
    /** Chave da situacao — tambem e o valor do filtro na URL. */
    statusKey(item) {
      return broadcastStatusKey(item);
    },
    /** Cancelado ou encerrado nao volta a aparecer: nao ha o que editar. */
    isEditable(item) {
      return !lockedReason(item);
    },
    statusLabel(item) {
      return STATUS_LABELS[this.statusKey(item)];
    },
    statusClass(item) {
      const label = this.statusLabel(item);
      if (label === 'No ar') return 'is-live';
      if (label === 'Cancelada') return 'is-cancelled';
      return 'is-muted';
    },
  },
};
</script>

<style scoped>
.bl-table { margin-bottom: 12px; }

.bl-actions__link { color: #1b59f8; margin-right: 10px; }
.bl-actions__link:hover, .bl-actions__link:focus { color: #1b59f8; }

.bl-actions { white-space: nowrap; }
.bl-actions i {
  margin-right: 12px;
  color: #4e5560;
  cursor: pointer;
}
.bl-actions i:last-child { margin-right: 0; }
.bl-actions i.bl-actions__danger { color: #ff445d; }

.bl-chip {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}
.bl-chip.is-live { background: #ecf9ef; color: #12b937; }
.bl-chip.is-cancelled { background: #fff0f2; color: #ff445d; }
.bl-chip.is-warn { background: #fff9eb; color: #ffb800; }
.bl-chip.is-muted { background: #f4f4f5; color: #4e5560; }

.bl-no-match { margin: 8px 0 16px; font-size: 13px; color: #4e5560; }
.bl-no-match a { margin-left: 6px; color: #1b59f8; }

.bl-warn {
  background: #fff9eb;
  color: #ffb800;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/broadcast/broadcastList.vue